<template>
    <div v-if="getProdList()?.length && this.modalProdSelection.isVisible">
        <div class="overlay" @click="handleButtonAction(modalProdSelection.buttons[0].buttonAction)"></div>
        <div class="modal-container">
            <div class="modal-title">
                <!-- <fa :icon="modalProdSelection.icon"></fa> -->
            </div>
            <div class="modal-body">
                <div class="prod-list-container">
                    <div class="products-item-container" v-for="(prod, prodKey) in getProdList()" :key="`${prodKey}`" @click="$emit('productClicked', prod)">
                      <div class="remove" @click="removeProduct(prod.productCode)">⛔</div>
                      <div class="prod-details">
                          <span class="prodName" v-text="prod.productName"></span>
                          <span class="prodDesc" v-text="prod.productDescription"></span>
                          <span class="prodPrice" v-text="new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(getMinPriceTxt(prod) || prod.price)"></span>
                      </div>
                      <img :src="getMockImage(prod) || prod.productImage">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button v-for="(btn, btnkey) in modalProdSelection.buttons" :key="btnkey" @click="handleButtonAction(btn.buttonAction)" v-text="btn.buttonText"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MinPriceController from '@/assets/controllers/MinPriceController'

export default {
  name: 'ModalProdSelection',
  props: ['modalOpen'],
  components: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['modalProdSelection', 'getMenu'])
  },
  methods: {
    ...mapActions(['closeModalProdSelection', 'removeProductFromList']),
    getMockImage (prod) {
      try {
        return require(`@/assets/mock/prodImg/${prod.productCode}.png`)
      } catch (error) {
        return null
      }
    },
    getMinPriceTxt (prod) {
      return MinPriceController.getMinPrice(prod)
    },
    getProdList () {
      const sf = this
      return sf.getMenu?.groups.map(p => p.products).flat().filter(p => sf.modalProdSelection.products.includes(p.productCode)) || []
    },
    handleButtonAction: function (btnAction) {
      if (btnAction) {
        this.$emit(btnAction, this.getProdList())
      }
      this.closeModalProdSelection()
    },
    removeProduct: function (code) {
      this.removeProductFromList(code)
    }
  }
}
</script>

<style lang="less" scoped>
.modal-container {
    position: fixed;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    z-index: 11;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: white;
    height: auto;
    width: fit-content;
    padding: 30px 10px;
    width: 85%;

    .modal-title {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        font-size: 2rem;
    }
    .modal-body {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 0 10px;
        flex-direction: column;
        flex-wrap: nowrap;
    }
    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        gap: 15px;
        button {
            color:white;
            background: var(--primaryColor);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            font-size: 1rem;
            min-width: 90px;
        }
    }
    .prod-list-container {
        position: relative;
        overflow: auto;
        height: 40vh;
        width: 100%;
    }
    .products-item-container {
        position: relative;
        padding: 10px 0;
        display: grid;
        grid-template-columns: calc(100% - 140px) 120px;
        grid-column-gap: 20px;
        margin-bottom: 10px;
        &:after{
            content: '';
            position: absolute;
            bottom: 0;
            left: 20px;
            right: 20px;
            height: 1px;
            background: #717171;
            opacity: 0.2;
            border-radius: 100%;
        }
        .remove {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(-15px, -50%);
          font-size: 15px;
          padding: 15px;
          z-index: 1;
        }
        .prod-details {
            .prodDesc {
                font-size: 14px;
                color: #717171;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                margin: 20px 0;
            }
            .prodPrice {
                margin-top: 20px;
                font-weight: bold;
            }
        }
        img {
            position: relative;
            height: 120px;
            width: 120px;
            display: block;
            object-fit: contain;
        }
    }
}
.overlay {
        position: fixed;
        top: 0; left: 0;
        height: var(--real-vh);
        width: 100vw;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.21);
        z-index: 10;
    }
</style>
